<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <b-col cols="8">
            <b-form-group>
              <b-form-select
                class="master-data"
                v-model="selected"
                :options="options"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="4"
            class="text-right"
            v-if="
              !['Service Type'].includes(
                options.filter((i) => i.value == selected)[0].text
              )
            "
          >
            
            <b-button variant="primary" class="round" @click="New()">
              {{ $t("add") }}

              {{ $t(options.filter((i) => i.value == selected)[0].text) }}
            </b-button>
            <b-button
              variant="primary"
              class="round ml-1"
              @click="onExportExcel()"
            >
              Export Excel
            </b-button>
          </b-col>
          <!-- Per Page -->
          <b-col cols="12">
            <!-- table body -->
            <vue-good-table
              :columns="fields"
              :rows="items"
              :search-options="{
                enabled: true,
                externalQuery: searchTerm,
              }"
              @on-row-dblclick="
                ['Service Type'].includes(
                  options.filter((i) => i.value == selected)[0].text
                )
                  ? ''
                  : Edit($event.row)
              "
              :row-style-class="rowStyleClassHover"
              :pagination-options="{
                enabled: true,
                perPage: perPage,
              }"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <span class="actions-td justify-content-center">
                    <b-button
                      v-b-tooltip.hover.top="'Update info!'"
                      variant="primary"
                      size="sm"
                      @click="Edit(props.row, props.row.id)"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button
                      v-b-tooltip.hover.top="'Delete'"
                      variant="danger"
                      v-if="!props.column.disabledDelete"
                      size="sm"
                      @click="Delete(props.row, props.row.id)"
                    >
                      <feather-icon icon="DeleteIcon" />
                    </b-button>
                  </span>
                </span>
                <span v-else-if="props.column.field === 'port_name'">
                  <span>{{ props.row.port_name }} </span>
                </span>
                <span v-else-if="props.column.field === 'region_id'">
                  <span
                    >{{ props.row.region_id }} - {{ props.row.region_name }}
                  </span>
                </span>
                <span v-else-if="props.column.field === 'location_type_id'">
                  <span
                    >{{ props.row.location_type_id }} -
                    {{ props.row.location_type_name }}
                  </span>
                </span>

                <span v-else-if="props.column.field === 'is_tms'">
                  <span
                    >{{
                      select2.type_surcharge.find(
                        (e) => e.id == props.row.is_tms
                      )
                        ? select2.type_surcharge.find(
                            (e) => e.id == props.row.is_tms
                          ).text
                        : ""
                    }}
                  </span>
                </span>
                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>

              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t("showing") }}</span>
                    <b-form-select
                      v-model="perPage"
                      :options="['10', '50', '100']"
                      class="mx-1"
                      @input="
                        (value) =>
                          props.perPageChanged({ currentPerPage: value })
                      "
                    />
                    <span class="text-nowrap">
                      {{ $t("entries") }}
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="totalItem"
                      :per-page="perPage"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="
                        (value) => props.pageChanged({ currentPage: value })
                      "
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal
      size="lg"
      no-close-on-backdrop
      id="modal-edit"
      :title="getTitle()"
      @ok="handleOk"
    >
      <!-- edit table -->
      <validation-observer ref="modalEdit">
        <b-row>
          <b-col
            :cols="i.cols != null ? i.cols : 6"
            v-for="i in fields.filter((i) => i.field !== 'action')"
            :key="i.field"
            :style="{ display: i.hiddenAdd ? 'none' : '' }"
          >
            <div v-if="!i.hiddenAdd">
              <validation-provider
                :name="i.label"
                #default="{ errors }"
                :rules="
                  !i.autoIncrement &&
                  (i.field == 'name' || i.field == 'id' || i.required)
                    ? 'required'
                    : ''
                "
                v-if="i.inputType == null && !i.checkBox && !i.radio"
              >
                <b-form-group>
                  <label
                    >{{ i.label
                    }}<span v-show="i.required" class="required">*</span>
                  </label>
                  <b-form-input
                    :disabled="
                      ((i.field === 'id' || i.disabled) && editMode) ||
                      i.autoIncrement
                    "
                    :state="errors.length > 0 ? false : null"
                    v-model.trim="currentItem[i.field]"
                    :placeholder="i.disabled ? '' : i.label"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                :name="i.label"
                #default="{ errors }"
                :rules="
                  i.field == 'name' || i.field == 'id' || i.required
                    ? 'required'
                    : ''
                "
                v-else-if="i.checkBox"
              >
                <b-form-group>
                  <b-form-checkbox
                    value="1"
                    unchecked-value="0"
                    v-model="currentItem[i.field]"
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ i.label }}
                  </b-form-checkbox>
                </b-form-group>
              </validation-provider>
              <validation-provider
                :name="i.label"
                #default="{ errors }"
                :rules="
                  i.field == 'name' || i.field == 'id' || i.required ? '' : ''
                "
                v-else-if="i.radio"
              >
                <b-form-group>
                  <label
                    >{{ i.label
                    }}<span v-show="i.required" class="required">*</span>
                  </label>

                  <b-form-radio-group
                    v-model="currentItem[i.field]"
                    disabled-field="0"
                    value-field="id"
                    text-field="text"
                    :state="errors.length > 0 ? false : null"
                    :options="select2[i.options]"
                    name="radios-stacked"
                    class="demo-inline-spacing"
                    stacked
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                :name="i.label"
                #default="{ errors }"
                :rules="
                  i.field == 'name' || i.field == 'id' || i.required
                    ? 'required'
                    : ''
                "
                v-else-if="!!i.inputType && !i.multiple"
              >
                <b-form-group>
                  <label
                    >{{ i.label
                    }}<span v-show="i.required" class="required">*</span>
                  </label>
                  <Select2
                    :state="errors.length > 0 ? false : null"
                    :placeholder="i.label"
                    v-model="currentItem[i.field]"
                    :options="select2[i.inputType]"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                :name="i.label"
                #default="{ errors }"
                :rules="
                  i.field == 'name' || i.field == 'id' || i.required
                    ? 'required'
                    : ''
                "
                v-else
              >
                <b-form-group>
                  <label
                    >{{ i.label
                    }}<span v-show="i.required" class="required">*</span>
                  </label>
                  <multiselect
                    v-model="currentItem[i.field]"
                    :multiple="true"
                    return="code"
                    :options="select2[i.inputType]"
                    :searchable="true"
                    :class="{ 'has-error': errors[0] }"
                    :show-labels="false"
                    :placeholder="i.label"
                    label="text"
                    track-by="text"
                  >
                  </multiselect>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
      <!-- cancel -->
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-edit')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handleOk"
          class="btn round"
        >
          {{ modal_title.includes("Update") ? $t("update") : $t("add") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { VueGoodTable } from "vue-good-table";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BFormSelect,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import exportFromJSON from "export-from-json";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      items: [],
      editMode: false,
      totalItem: 0,
      permisItems: [],
      perPage: 10,
      searchQuery: "",
      searchTerm: "",
      currentItem: {},
      selected: "AccDept",
      select2: {
        locationTypes: [],
        regions: [],

        country: [],
        cont_group: [
          { id: "Unit", text: "Unit" },
          { id: "time", text: "time" },
          { id: "van truck", text: "van truck" },
          { id: "Container truck", text: "Container truck" },
          { id: "packaging", text: "packaging" },
        ],
        type_surcharge: [
          { id: 0, text: "FAST" },
          { id: 1, text: "TMS" },
        ],
        customer_level: [],
        customer_type: [],
        catelogys: [],
      },
      options: [
        {
          value: "AccDept",
          text: this.$i18n.t("Accountable Department"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },

            {
              field: "RoleName",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
              // disabled: true,
            },

            {
              field: "Description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: true,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "TMS ID",
              disabled: true,
              autoIncrement: true,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "Bank",
          text: this.$i18n.t("bank"),
          fields: [
            {
              field: "code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Code"),
              required: true,
              disabled: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Descriptions"),
              required: true,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "BusinessType",
          text: this.$i18n.t("businessType"),
          fields: [
            {
              label: "ID",
              field: "id",
              type: "number",
              filterOptions: { enabled: true, placeholder: "ID" },
              disabled: true,
              autoIncrement: true,
              hidden: true,
              width: "100px",
            },
            {
              field: "name",
              label: this.$i18n.t("name"),
              filterOptions: { enabled: true, placeholder: "Name" },
              required: true,
              width: "600px",
              sortable: false,
            },
            {
              field: "descriptions",
              label: this.$i18n.t("Descriptions"),
              filterOptions: { enabled: true, placeholder: "Descriptions" },
              required: false,
              width: "600px",
              sortable: false,
            },
            {
              field: "local_descriptions",
              label: this.$i18n.t("Local Descriptions"),
              filterOptions: {
                enabled: true,
                placeholder: "Local Descriptions",
              },
              required: false,
              width: "600px",
              sortable: false,
            },
            {
              field: "action",
              label: this.$i18n.t("actions"),
              width: "100px",
              sortable: false,
            },
          ],
        },
        {
          value: "CustomsSubDept",
          text: this.$i18n.t("Customs Sub-department"),
          fields: [
            {
              field: "code",
              filterOptions: { enabled: true, placeholder: "" },
              required: true,
              label: "Code",
            },

            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
            },

            {
              field: "customs_department",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Customs department"),
              required: true,
            },
            {
              field: "port_code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Port code"),
              required: false,
              inputType: "port",
              multiple: true,
              hidden: true,
            },
            {
              field: "port_name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Port name"),
              hiddenAdd: true,
            },

            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: false,
              cols: 12,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "Catelogy",
          text: this.$i18n.t("Catelogy"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },

            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
              // disabled: true,
            },
            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: false,
              cols: 12,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "GoodsType",
          text: this.$i18n.t("Kind of cargo"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
            },
            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              cols: 12,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              cols: 12,
              label: "TMS ID",
              // hidden: true,
              autoIncrement: true,
              // required: true,
              disabled: true,
            },
            {
              field: "local_description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Description"),
              cols: 12,
            },
            {
              field: "fast_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Fast ID"),
              cols: 12,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "Company",
          text: this.$i18n.t("company"),
          fields: [
            {
              field: "tax_code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("taxCode"),
              required: true,
              disabled: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("companyName"),
              required: true,
            },
            {
              field: "name_vi",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Name"),
              required: true,
              hidden: true,
            },
            {
              field: "acronym",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Abbreviations"),
              required: true,
            },
            {
              field: "fast_id",
              filterOptions: { enabled: true, placeholder: "" },
              cols: 6,
              label: "FAST ID",
              // required: true,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "TMS Vendor ID",
              // hidden: true,
              cols: 6,
              // required: true,
            },
            {
              field: "address",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("address"),
              required: true,
              cols: 12,
            },
            {
              field: "address_vi",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Address"),
              required: true,
              cols: 12,
              hidden: true,
            },
            {
              field: "telephone",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Tel"),
              hidden: true,
              required: false,
            },
            {
              field: "country_code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Country Code"),
              required: false,
              hidden: true,
            },
            {
              field: "region_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("region"),
              inputType: "regions",
              hidden: true,

              required: false,
            },
            {
              field: "catelogy_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Catelogy"),
              inputType: "catelogys",
              hidden: true,
              required: false,
            },
            {
              field: "customer_type_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Customer type"),
              inputType: "customer_type",
              hidden: true,
              required: false,
            },
            {
              field: "customer_level_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Customer level"),
              inputType: "customer_level",
              required: false,
              hidden: true,
            },
            {
              field: "action",
              label: this.$i18n.t("Actions"),
              width: "100px",
              disabledDelete: true,
            },
          ],
        },
        {
          value: "ContType",
          text: "Unit",
          text: this.$i18n.t("Unit"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              type: "number",
              type: "number",

              disabled: true,
              autoIncrement: true,
            },
            {
              field: "code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("code"),
              required: true,
              sortable: false,
            },
            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: true,
              sortable: false,
            },
            {
              field: "group",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("group"),
              inputType: "cont_group",
              required: true,
              sortable: false,
            },
            {
              field: "fast_id",
              filterOptions: { enabled: true, placeholder: "" },
              disabled: true,
              autoIncrement: true,
              hidden: true,
              label: "FAST ID",
              // required: true,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              disabled: true,
              autoIncrement: true,
              label: "TMS ID",

              hidden: true,
              // required: true,
            },
            {
              field: "local_descriptions",
              label: this.$i18n.t("Local Descriptions"),
              filterOptions: {
                enabled: true,
                placeholder: "Local Descriptions",
              },
              required: false,
              width: "600px",
              sortable: false,
            },

            {
              field: "action",
              label: this.$i18n.t("actions"),
              width: "100px",
              sortable: false,
            },
          ],
        },
        {
          value: "Country",
          text: this.$i18n.t("country"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              type: "number",
              type: "number",
              disabled: true,
              autoIncrement: true,
            },
            {
              field: "code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("countryCode"),
              required: true,
              disabled: true,
              sortable: false,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("countryName"),
              required: true,
              sortable: false,
            },
            {
              field: "local_name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local name "),
              required: false,
              sortable: false,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("TMS ID"),
              required: false,
              sortable: false,
            },
            {
              field: "action",
              label: "Actions",
              width: "100px",
              sortable: false,
            },
          ],
        },
        {
          value: "CustomerLevel",
          text: this.$i18n.t("CustomerLevel"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },

            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
              // disabled: true,
            },
            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: false,
              cols: 12,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "CustomerType",
          text: this.$i18n.t("CustomerType"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },

            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
              // disabled: true,
            },
            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: false,
              cols: 12,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "CustomsType",
          text: this.$i18n.t("customsType"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("ID"),
              disabled: true,
              text: "number",
              autoIncrement: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
              sortable: false,
            },
            {
              field: "descriptions",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Descriptions "),
              required: false,
              sortable: false,
            },
            {
              field: "local_descriptions",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Descriptions"),
              required: false,
              sortable: false,
            },
            {
              field: "action",
              label: this.$i18n.t("actions"),
              width: "100px",
              sortable: false,
            },
          ],
        },
        {
          value: "HandedType",
          text: this.$i18n.t("Handle type"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },

            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
              // disabled: true,
            },
            {
              field: "local_descriptions",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Descriptions"),
              required: false,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        // {
        //   value: "Deport",
        //   text: "Port/Depot/ICD",
        //   fields: [
        //     {
        //       field: "id",
        //       filterOptions: { enabled: true, placeholder: "" },
        //       label: this.$i18n.t("code"),
        //       disabled: true,
        //       autoIncrement: true,
        //     },
        //     {
        //       field: "type",
        //       filterOptions: { enabled: true, placeholder: "" },
        //       label: this.$i18n.t("type"),
        //       required: true,
        //     },
        //     {
        //       field: "name",
        //       filterOptions: { enabled: true, placeholder: "" },
        //       label: this.$i18n.t("name"),
        //       required: true,
        //     },
        //     {
        //       field: "address",
        //       filterOptions: { enabled: true, placeholder: "" },
        //       label: this.$i18n.t("address"),
        //       cols: 12,
        //       required: true,
        //     },
        //     { field: "action", label: this.$i18n.t("actions"), width: "100px" },
        //   ],
        // },
        {
          value: "FeeType",
          text: this.$i18n.t("surcharge"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
            },
            {
              field: "code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Code"),
              required: true,
            },
            {
              field: "vat",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Vat"),
              required: true,
            },
            {
              field: "currency",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Currency"),
              required: true,
            },
            {
              field: "name_vi",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Name"),
              required: true,
            },
            {
              field: "dbt",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Dbt"),
              hidden: true,
              cols: 2,

              checkBox: true,
            },
            {
              field: "kbck",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("KBKC"),
              hidden: true,
              cols: 2,
              checkBox: true,
            },
            {
              field: "freight",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Freight"),
              hidden: true,
              cols: 2,
              checkBox: true,
            },
            {
              field: "logistics",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Logistics"),
              hidden: true,
              cols: 2,
              checkBox: true,
            },
            {
              field: "trucking",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Trucking"),
              hidden: true,
              cols: 2,
              checkBox: true,
            },

            {
              field: "is_tms",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Group"),
              options: "type_surcharge",
              required: true,
              radio: true,
            },
            // {
            //   field: "description",
            //   filterOptions: { enabled: true, placeholder: "" },
            //   label: this.$i18n.t("description"),
            //   required: true,
            // },
            {
              field: "fast_id",
              // filterOptions: { enabled: true, placeholder: "" },
              disabled: true,
              // tdClass: "d-none",
              // thClass: "d-none",
              hidden: true,
              label: "FAST ID",
              // required: true,
              autoIncrement: true,
            },
            {
              field: "tms_id",
              // filterOptions: { enabled: true, placeholder: "" },
              disabled: true,
              label: "TMS ID",
              // tdClass: "d-none",
              // thClass: "d-none",
              hidden: true,
              // required: true,
              autoIncrement: true,
            },

            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "Incoterm",
          text: this.$i18n.t("incoterms"),
          fields: [
            {
              field: "code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("code"),
              required: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Descriptions"),
              required: true,
            },
            {
              field: "local_descriptions",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Descriptions"),
              required: false,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "Location",
          text: this.$i18n.t("location"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },
            {
              field: "abbreviations",
              filterOptions: { enabled: true, placeholder: "" },
              label: "Abbreviations",
              required: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Name"),
              required: true,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "TMS ID",
            },

            {
              field: "address",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("address"),
              required: true,
              cols: 12,
            },
            {
              field: "region_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("region"),
              inputType: "regions",

              required: true,
            },
            {
              field: "location_type_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("locationTypes"),
              inputType: "locationTypes",
              required: true,
            },
            {
              field: "latitude",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Latitude"),
              required: true,
            },
            {
              field: "longitude",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Longtitude"),
              required: true,
            },
            {
              field: "local_name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Name"),
              required: false,
            },
            {
              field: "local_address",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Address"),
              required: false,
            },

            { field: "action", label: "Actions", width: "100px" },
          ],
        },
        {
          value: "Port",
          text: this.$i18n.t("port"),
          fields: [
            {
              field: "code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("code"),
              required: true,
              disabled: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
            },
            {
              field: "country_code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("countryCode"),
              required: true,
              inputType: "country",
              isPostName: true,
              hidden: true,
              postName: "country_name",
              cols: 4,
            },
            {
              field: "country_name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("countryName"),
              required: true,
              inputType: "country",
              hiddenAdd: true,
              cols: 4,
            },
            {
              field: "type",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Type"),
              required: false,
              cols: 4,
            },
            {
              field: "fast_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Fast ID"),
              required: false,
              hidden: true,

              cols: 4,
            },
            {
              field: "action",
              label: this.$i18n.t("actions"),
              width: "100px",
              disabledDelete: true,
            },
          ],
        },
        {
          value: "LocationTypes",
          text: this.$i18n.t("locationTypes"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              hidden: true,
              disabled: true,
              autoIncrement: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "TMS ID",
              required: true,
            },
            {
              field: "desc",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: true,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },

        {
          value: "ServiceType",
          text: this.$i18n.t("serviceType"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              hidden: true,
              autoIncrement: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
            },
            {
              field: "descriptions",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Descriptions"),
              required: false,
            },
            {
              field: "local_descriptions",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Local Descriptions"),
              required: false,
            },
          ],
        },
        {
          value: "ShippingLine",
          text: this.$i18n.t("Carriers"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              hidden: true,
              autoIncrement: true,
            },
            {
              field: "code",
              filterOptions: { enabled: true, placeholder: "" },
              required: true,
              label: this.$i18n.t("code"),
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Descriptions"),
              required: true,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "TMS ID",
            },
            {
              field: "local_descriptions",
              filterOptions: { enabled: true, placeholder: "" },
              label: "Local Descriptions",
            },
            {
              field: "fast_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "Fast ID",
            },
            { field: "action", label: this.$i18n.t("Actions"), width: "100px" },
          ],
        },
        {
          value: "Region",
          text: this.$i18n.t("region"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: "Region",
              label: this.$i18n.t("region"),
              required: true,
            },
            {
              field: "local_region",
              filterOptions: { enabled: true, placeholder: "" },
              label: "Local Region",
            },
            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: false,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "TMS ID",
            },
            {
              field: "local_descriptions",
              filterOptions: { enabled: true, placeholder: "" },
              label: "Local Descriptions",
            },

            {
              field: "region_group",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("Region Group"),
              inputType: "regions",

              required: false,
            },

            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "TransportType",
          text: this.$i18n.t("Shipping Type"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              cols: 4,
              disabled: true,
              hidden: true,
              autoIncrement: true,
            },
            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              cols: 4,
              required: true,
            },
            {
              field: "tms_id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "TMS ID",
              // hidden: true,
              cols: 4,
              // autoIncrement: true,
              required: true,
              // disabled: true,
            },
            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: false,
            },
            {
              field: "local_descriptions",
              filterOptions: { enabled: true, placeholder: "" },
              label: "Local Descriptions",
            },
            // { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "SystemConfig",
          text: this.$i18n.t("systemConfig"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              autoIncrement: true,
            },

            {
              field: "code",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("code"),
              required: true,
              disabled: true,
            },
            {
              field: "value",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("value"),
              required: true,
            },
            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: true,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
        {
          value: "Vessel",
          text: this.$i18n.t("Vessel"),
          fields: [
            {
              field: "id",
              filterOptions: { enabled: true, placeholder: "" },
              label: "ID",
              disabled: true,
              hidden: true,
              autoIncrement: true,
            },

            {
              field: "name",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("name"),
              required: true,
              // disabled: true,
            },
            {
              field: "description",
              filterOptions: { enabled: true, placeholder: "" },
              label: this.$i18n.t("description"),
              required: false,
              cols: 12,
            },
            { field: "action", label: this.$i18n.t("actions"), width: "100px" },
          ],
        },
      ],
      fields: [],
    };
  },
  mounted() {
    this.fields = this.options[0].fields;
    useJwt.get("masterData?data=Country", {}).then((response) => {
      this.select2.country = this.$Utils.formatOption(response.data.result);
    });
    useJwt.get("masterData?data=Port", {}).then((response) => {
      this.select2.port = this.$Utils.formatOption(response.data.result);
    });
    useJwt
      .get("masterData", { params: { data: "LocationTypes" } })
      .then((response) => {
        this.select2.locationTypes = response.data.result;
      });
    useJwt.get("masterData?data=Region").then((response) => {
      this.select2.regions = this.$Utils.formatOption(response.data.result);
    });
    useJwt.get("masterData?data=Catelogy").then((response) => {
      this.select2.catelogys = response.data.result;
    });
    useJwt.get("masterData?data=CustomerType").then((response) => {
      this.select2.customer_type = response.data.result;
    });
    useJwt.get("masterData?data=CustomerLevel").then((response) => {
      this.select2.customer_level = response.data.result;
    });
    this.fetchGroup();
  },

  // take change select
  watch: {
    perPage: function (n, o) {
      this.fetchGroup();
    },
    searchQuery: function (n, o) {
      this.fetchGroup();
    },
    selected: function (n, o) {
      this.fields = this.options.filter(
        (i) => i.value == this.selected
      )[0].fields;
      this.fetchGroup();
    },
    "$i18n.locale": function (newVal, oldVal) {
      this.fields = [];
      this.$nextTick(() => {
        this.fetchGroup();
        // Add the component back in
        // this.renderComponent = false;
        this.fields = this.options.filter(
          (i) => i.value == this.selected
        )[0].fields;
        // (this.renderComponents= true);
      });
    },
  },
  methods: {
    onExportExcel() {
      const data = JSON.parse(JSON.stringify(this.items));
      const result = this.options.filter((i) => i.value == this.selected)[0];
      // result.fields.label
      // 1 Duyệt item with a label for the export
      const fields = result.fields;
      const itemNew = data.map((i) => {
        const item = {};
        fields.forEach((e) => {
          if (e.label != "Actions") {
            item[e.label] = i[e.field] || "";
          }
        });
        return item;
      });


      const exportType = exportFromJSON.types.xls;
      exportFromJSON({ data: itemNew, fileName: result?.text, exportType });
    },
    columnFilterFn(e) {},
    // function get name title
    getTitle() {
      if (this.editMode) {
        return (
          this.$i18n.t("update") +
          " " +
          this.options.filter((i) => i.value == this.selected)[0].text
        );
      } else {
        return (
          this.$i18n.t("add") +
          " " +
          this.options.filter((i) => i.value == this.selected)[0].text
        );
      }
    },

    fetchGroup: function () {
      useJwt
        .get("masterData?data=" + this.selected, {
          params: {
            search: this.searchQuery.trim(),
            page: 1,
            pageSize: this.perPage,
          },
        })
        .then((response) => {
          this.items = response.data.result;

          if (
            this.options
              .filter((i) => i.value === this.selected)[0]
              ?.fields.filter((e) => e.multiple).length > 0
          ) {
            // tim kieu du lieu multiple trong cac field cua table hien tai
            // sau do tim cac field co kieu du lieu multiple
            // sau do tim cac item co field do co gia tri
            // sau do tach cac gia tri cua field do thanh mang
            // sau do tim cac gia tri trong mang do co trong select2
            // sau do gan lai gia tri cho item
            const multipleFields = this.options
              .filter((i) => i.value === this.selected)[0]
              .fields.filter((e) => e.multiple);
            for (let index = 0; index < multipleFields.length; index++) {
              const element = multipleFields[index];
              for (let index = 0; index < this.items.length; index++) {
                const item = this.items[index];
                if (item[element.field]) {
                  let arr = item[element.field].split(",");
                  item[element.field] = this.select2[element.inputType].filter(
                    (e) => arr.includes(e.code + "")
                  );
                }
                this.items[index] = item;
              }
            }
          }

          this.totalItem = response.data.meta.total;
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title:
                "Error getting list " +
                this.options.filter((i) => i.value === this.selected)[0].text,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    Edit(item, index, button) {
      this.currentItem = { ...item };
      this.editMode = true;
      this.modal_title =
        this.$i18n.t("update") +
        " " +
        this.options.filter((i) => i.value === this.selected)[0].text;
      this.$bvModal.show("modal-edit");
    },
    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title =
        this.$i18n.t("add") +
        " " +
        this.options.filter((i) => i.value === this.selected)[0].text;

      if (
        this.options.filter((i) => i.value === this.selected)[0].text ==
        "Surcharge"
      ) {
        this.currentItem.is_tms = 0;
        this.currentItem.dbt = 0;
        this.currentItem.kbck = 0;

        this.currentItem.freight = 0;
        this.currentItem.logistics = 0;
        this.currentItem.trucking = 0;
      }

      this.$bvModal.show("modal-edit");
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();

      var validate = await this.$refs.modalEdit.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the input data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      // this.$loading.show();

      let dataCover = { ...this.currentItem };
      if (
        this.options
          .filter((i) => i.value === this.selected)[0]
          ?.fields.filter((e) => e.isPostName).length
      ) {
        const isPostNameFields = this.options
          .filter((i) => i.value === this.selected)[0]
          .fields.filter((e) => e.isPostName);
        for (let index = 0; index < isPostNameFields.length; index++) {
          const element = isPostNameFields[index];
          if (dataCover[element.field]) {
            dataCover[element.postName] =
              this.select2[element.inputType].filter(
                (e) => e.code == dataCover[element.field]
              )[0]?.text || "";
          }
        }
      }
      if (
        this.options
          .filter((i) => i.value === this.selected)[0]
          ?.fields.filter((e) => e.multiple).length > 0
      ) {
        const multipleFields = this.options
          .filter((i) => i.value === this.selected)[0]
          .fields.filter((e) => e.multiple);
        for (let index = 0; index < multipleFields.length; index++) {
          const element = multipleFields[index];
          if (dataCover[element.field] && dataCover[element.field].length > 0) {
            dataCover[element.field] = dataCover[element.field]
              .map((e) => e.code + "")
              .toString();
          } else {
            dataCover[element.field] = "";
          }
        }
      }
      if (!this.editMode) {
        useJwt
          .post("masterData?objectType=" + this.selected, dataCover)
          .then((response) => {
            this.$store.commit("masterData/RESET_STATE");

            this.fetchGroup();
            this.$bvModal.hide("modal-edit");
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  this.$i18n.t("add") +
                  " " +
                  this.options.filter((i) => i.value === this.selected)[0]
                    .text +
                  " success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  "Insert fail " +
                  this.options.filter((i) => i.value === this.selected)[0].text,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.$loading.hide();
          });
      } else {
        useJwt
          .put("masterData?objectType=" + this.selected, dataCover)
          .then((response) => {
            this.$store.commit("masterData/RESET_STATE");

            this.fetchGroup();
            this.$bvModal.hide("modal-edit");
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  this.$i18n.t("") +
                  " " +
                  this.options.filter((i) => i.value === this.selected)[0]
                    .text +
                  " success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  "Update fail " +
                  this.options.filter((i) => i.value === this.selected)[0].text,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.$loading.hide();
          });
      }
    },
    rowStyleClassHover(row) {
      return "VGT-row-hover";
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm(
        this.$i18n.t("areYouDeleteitem") +
          this.options.filter((i) => i.value === this.selected)[0].text,
        {
          title:
            this.$i18n.t("delete") +
            " " +
            this.options.filter((i) => i.value === this.selected)[0].text,
          size: "sm",
        }
      );
      if (res) {
        useJwt
          .delete(
            `masterData?objectType=${this.selected}&id=${this.currentItem.id}&code=${this.currentItem.code}`,
            {}
          )
          .then((response) => {
            this.fetchGroup();
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  this.$i18n.t("delete") +
                  " " +
                  this.options.filter((i) => i.value === this.selected)[0]
                    .text +
                  " success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  "Delete fail" +
                  this.options.filter((i) => i.value === this.selected)[0].text,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    },
  },
};
</script>
<style>
.select2-selection--single {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}
.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}

.master-data {
  background: #fff
    url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    right 1rem center/10px 6px no-repeat;
  border-radius: 1.5rem;
}

.select2-selection__arrow {
  background: none;
  display: none !important;
}
.vgt-table td,
.vgt-table th {
  /* padding: 0.25em 0.75em !important; */
  vertical-align: middle !important;
  font-size: 1rem;
}
.vgt-table th {
  text-align: center;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style>
.VGT-row-hover:hover {
  background-color: #cce7e7;
}

.demo-inline-spacing > * {
  margin-top: 0.7rem;
}
</style>
